// extracted by mini-css-extract-plugin
module.exports = {"shareLinkIconWrapper":"mobileShareLink_shareLinkIconWrapper__1oNWU","shareLinkIcon":"mobileShareLink_shareLinkIcon__MpKTT"};